import { FacilityDailyWorkingHours } from '@/types/generated';
import { DAYS_OF_WEEK, DAYS_OF_WEEK_SHORT_HAND } from '@/constants';

import { getDayOfWeekFromDate } from '../getDayOfWeek';
import { get12HourTime } from '../';

export const getWorkingHours = (workingHours: FacilityDailyWorkingHours[], isFullName?: boolean) => {
	const hours = workingHours.reduce((acc, cur) => {
		const day = getDayOfWeekFromDate(cur.date as Date);

		if (cur.open?.from === null || cur.open?.to == null) {
			return {
				...acc,
				[day]: 'Closed',
			};
		}

		const startTime = get12HourTime(cur.open.from as unknown as string);
		const endTime = get12HourTime(cur.open.to as unknown as string);
		return {
			...acc,
			[day]: cur.open.from !== null ? `${startTime} - ${endTime}` : 'Closed',
		};
	}, {} as Record<string, string>);

	const fullWeekHours = DAYS_OF_WEEK.map((fullDayName) => {
		const day = isFullName ? fullDayName : DAYS_OF_WEEK_SHORT_HAND[fullDayName];
		if (!hours[fullDayName]) {
			return {
				day,
				hours: 'Closed',
			};
		}
		return {
			day,
			hours: hours[fullDayName],
		};
	});
	return fullWeekHours;
};
